import { Controller } from 'react-hook-form';
import { FormControlLabel, Switch } from '@mui/material';

export const FormCheckbox = ({ name, control, label, readOnly, disabled }) => (
  <Controller
    name={name}
    control={control}
    disabled={disabled}
    render={({ field }) => (
      <FormControlLabel control={<Switch {...field} checked={!!field.value} readOnly={readOnly} />} label={label} />
    )}
  />
);
